export const marketingEmailMapper = (state) => ({
  id: state.quoteDetails.id,
  quoteNumber: state.quoteDetails.quoteNumber,
  dateOfBirth: state.driverDetails.mainDriver.dob,
  postcode: state.addressSearchInfo.addressInfo.matchedAddress.postcode,
  emailAddress: state.policyHolderDetails.contactEmailAddress,
  retrieveQuotePath: process.env.REACT_APP_RETRIEVE_QUOTE_URL,
  mobileNumber: state.policyHolderDetails.marketingContactNumber,
});
